import styled from 'styled-components';
import { container } from '@lendi-ui/container';
import { depth } from '@lendi-ui/depth';
import { mt, my, px, py } from '@lendi-ui/spacing';
import { body, heading } from '@lendi-ui/typography';

export const HeroPanelWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: start;
  height: 15rem;
  ${depth(2)}
`;

export const HeroPanelContent = styled.div`
  ${container()}
  ${px({ mobile: 'sm', desktop: 'xxs' })}
  ${py('md')}
`;

export const Category = styled.h5`
  text-transform: uppercase;
  ${body({ size: 'sm', color: 'shade.0' })}
  ${my('nil')}
`;

export const Title = styled.h1`
  ${heading({ size: 'lg', color: 'shade.0' })}
  ${mt('nil')}
`;
